import type { JSX } from 'react';
import React from 'react';

import type { IEvent } from '@feathr/blackbox';

import SelectOption from './SelectOption';
import type { ISelectOptionProps, ISelectSingleValueProps } from './SelectOptions.types';
import SelectSingleValue from './SelectSingleValue';

import * as eventStyles from '../EventSwitcher/EventSwitcher.css';
import * as selectStyles from './SelectOptions.css';

import noImg from 'images/no-img.png';

export function EventOption<T extends IEvent>(props: Readonly<ISelectOptionProps<T>>): JSX.Element {
  return (
    <SelectOption {...props}>
      <div style={{ display: 'flex' }}>
        <div className={selectStyles.contentWrapper}>
          <div
            style={{
              width: '35px',
              height: '35px',
              backgroundImage: `url("${props.data.logo || noImg}")`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
            }}
          />
        </div>
        <div className={'name'}>
          <span>{props.data.name}</span>
        </div>
      </div>
    </SelectOption>
  );
}

export function EventSingleValue<T extends IEvent>(
  props: Readonly<ISelectSingleValueProps<T>>,
): JSX.Element {
  return (
    <SelectSingleValue {...props}>
      <div className={eventStyles.navBarEvent}>
        <span
          className={eventStyles.navBarEventLogo}
          style={{ backgroundImage: `url("${props.data.logo || noImg}")` }}
        />
        {props.data.name}
      </div>
    </SelectSingleValue>
  );
}
